import { t } from "@lingui/macro"
import { observer } from "mobx-react"
import { useMemo } from "react"

import { IStatusChipProps, StatusChip } from "src/components/StatusChip"

interface IProps {
    status: NoticeBoardStatus
}

export const NoticeBoardStatusChip = observer(({ status }: IProps) => {
    const chipProps = useMemo((): IStatusChipProps => {
        if (status === "published") {
            return {
                state: "positive",
                label: t`notice-board-view.status-chip-published-status`,
            }
        } else if (status === "unpublished") {
            return {
                state: "negative",
                label: t`notice-board-view.status-chip-unpublished-status`,
            }
        } else {
            return {
                state: "neutral",
                label: t`notice-board-view.status-chip-scheduled-status`,
            }
        }
    }, [status])

    return <StatusChip {...chipProps} />
})
